/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */

import { Base } from '../base'
import { Car } from '../car.entity'
import { WifiInfo } from '../WifiInfo';

export class CarDTO {
  _page ="CarDTO"
  id: string = ''
  name: string = ''
  make: string = ''
  model: string = ''
  licensePlate: string = ''
  batteryVoltage: number = 0
  batteryCapacity: number = 0
  batteryType: string = 'LEAD_ACID'
  image: string
  installedDeviceId:string
  wifi: WifiInfo = WifiInfo.factory()

  voltageThresholds: {
    min: number
    max: number
  }

  currentThresholds: {
    min: number
    max: number
  }

  /*voltageThresholds: VoltageThresholds = new VoltageThresholds()
  currentThresholds: CurrentThresholds = new CurrentThresholds()
*/
  last: {
    voltage: {
      status: string
      value: number
    },
    current: {
      status: string
      value: number
    },
    temperature: {
      status: string
      value: number
    },
    humidity: {
      status: string
      value: number
    },
    pressure: {
      status: string
      value: number
    },
    timestamp: {
      status: string
      value: number
    },
    wifiSsid: {
      status: "",
      value: ""
    }
  }


  public setDTOFromModel(car: Car) {

    Base.log("[" + this._page + "] setDTOFromModel")
    Base.log(car)

    this.make = car.make
    this.model = car.model
    this.name = car.name
    this.licensePlate = car.licensePlate
    if (car.id!=="temp") {
      this.id = car.id
    }
    this.wifi = car.wifi
    //this.image = car.image
    this.batteryCapacity = +car.batteryCapacity
    this.batteryType = car.batType
    this.batteryVoltage = +car.batteryVoltage
    this.installedDeviceId = car.installedDeviceId

    this.voltageThresholds = car.voltageThresholds
    this.currentThresholds = car.currentThresholds

    /*
    if (car.voltage !== undefined) {
      this.voltageThresholds.min = +car.voltage.lower
      this.voltageThresholds.max = +car.voltage.upper
    } else {
      this.voltageThresholds.min = -999
      this.voltageThresholds.max = +999
    }

    if (car.amperage !== undefined) {
      this.currentThresholds.min = +car.amperage.lower
      this.currentThresholds.max = +car.amperage.upper
    }
    */

    Base.log("[" + this._page + "] --dto---")
    console.log(car.last)
    Base.log("[" + this._page + "] --this---")
    console.log(this.last)

    //this.last = car.last
    Base.log("[" + this._page + "] carDTO:")
    Base.log(this)
  }

  decorateImage(img) {
    if (img === undefined || img === null || img.length < 200) {
      img = ''
    } else {
      if (img !== undefined && img !== null && !(img.startsWith('data'))) {
        img = 'base64,' + img
      }
    }

    return img
  }
}


